module.exports = __webpack_public_path__ + "img/img2.9ad510a4.svg";